import React, { useState, useEffect, useContext } from 'react';
import { axios } from '../services/ServiceUtils';
import LanguageContext from "./LanguageContext";

const PrivacyContext = React.createContext();
const { Provider, Consumer } = PrivacyContext;

const PrivacyProvider = props => {
  const [privacy, setPrivacy] = useState({
    header: '',
    privacy: '',
    error: false,
    errorStatus: false,
  });
  const {language} = useContext(LanguageContext);
  const { children } = props;
  const privacyError = status => {
    setPrivacy({ header: '', privacy: '', error: true, errorStatus: status });
  };
  useEffect(() => {
    axios
      .get('api/privacy',{
        headers:{
          'Content-Language': `${language.locale}`
        }
      })
      .then(result => {
        if (!result.data.privacy) {
          privacyError(200);
        } else {
          setPrivacy({
            header: result.data.title,
            privacy: result.data.privacy,
            error: false,
            errorStatus: false,
          });
        }
      })
      .catch(e => {
        privacyError(e.response.status);
        // eslint-disable-next-line
        console.error('request error', e.response.status);
      });
  }, [language]);

  return <Provider value={privacy}>{children}</Provider>;
};

export { PrivacyProvider, Consumer as ConsumerProvider };
export default PrivacyContext;
